import http from './services/http-business.ts';

export const Api = http;
export default Api;
